<template>
  <div class="mobile-home" :class="{ 'landscape': isLandscape }">
    <!-- 加载页 -->
    <div v-if="showLoading" class="loading-page">
      <!-- <img class="loading-logo" src="../assets/17dba2e30afc8590182254fe68bcc7b0.png" alt="logo" /> -->
      <img class="loading-logo" src="../assets/887a6e99b6468ceb22eb0695015a18e3.png" alt="logo">
      <!-- <img class="loading-logo" src="../assets/logo.png" alt="logo" /> -->
      <div class="loading-progress-container">
        <div class="loading-progress-text">{{ loadingPercent }}%</div>
        <div class="loading-progress-bar">
          <div class="loading-progress-inner" :style="{ width: loadingPercent + '%' }"></div>
        </div>
      </div>
    </div>
    <!-- 微信浏览器提示 -->
    <div v-if="isWechat && showWechatGuide" class="wechat-guide-mask">
      <div class="wechat-guide-content no-header">
        <div class="wechat-guide-arrow">
          <!-- 用base64图片替换SVG箭头 -->
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAACICAMAAABQgAwUAAAAMFBMVEUAAADY2NjY2NjY2NjY2NjY2NjY2NjY2NjX19fY2NjY2NjY2NjY2NjY2NjY2NjY2Njr/TvvAAAAD3RSTlMAxy89c9CdTRyG7lvcD7FzqbJAAAACFklEQVR42uWYy4rkMBAErZdlPdzx/3+7LAw0tH0Y2orDsnnyKQlSVaWytoc6xrEpigFoinUAIBnWABAE5woW9o6GPbGwI1jYGSzsgoV9goU9wMLe0bA7FnYCC7uBhV2wsE+wsAdY2AENGyzsBBZ2Q8MuWNgH94pLbgELO6Bhg4VdwcJuaNgTCzuChZ3Bwg5o2GBhV7CwdzTsjoUdwcLOYGEXLOwTLOwBFvaOht2xsBNY2I1f6lhaenvhrfpkAblab+k9b/OD0iuX2F9/x8D+7ZL2pmpbuj+6o3Vg//oWmPU9p65VkXL6+oIJ8S738nwj62Pb1lvHACH+fBs7sG59U3yrVD3rce3GVcp8qGkPAGTprQUYy6xfaE8i82b6S7/pfZnzdYQIHeOXdfYKpHoFcmrvWlM8RW+CDO8JMWoNM/+FeyB4UfMpL48g5qG1Iqc29YI3mqq2knXvEJu2onJoQy9ok4mkQZf/GjqitUvQyqN6SU8NOvOhHq25xNCWj6LFQdLiyKuaZWpxBC2OrFVHxdryElbQsVtBx6KN0qAd4a71yo610uxa2b0s5xg052I5p26d4MCqusZFwzrAnqQhSogSMnkNcr+GUS3kEKWS62NJFlNCToWLZpWMe14RReGqdjz2PfNECbkGbrQ/Nj5q5y7j8/HRTW5UhvHfA7Mdzitji8rfWsgX3gVZ91eO22odKed6LLf9A/sRnc74RV7lAAAAAElFTkSuQmCC" alt="arrow" style="width:90px;height:90px;object-fit:contain;" />
        </div>
        <div class="wechat-guide-tip">{{ $t('message.tip.wechat') }}</div>
        <div class="wechat-guide-icon-area">
          <div v-if="isIOS" class="wechat-guide-browser">
            <img style="width: 65px;height: 64px;" src="../assets/macLlq.png" alt="">
            <div class="wechat-guide-browser-text">{{ $t('message.tip.safari') }}</div>
          </div>
          <div v-else class="wechat-guide-browser">
            <img style="width: 64px;height: 64px;" src="../assets/azLlq.png" alt="">
            <!-- <svg width="64" height="64" viewBox="0 0 64 64"><circle cx="32" cy="32" r="32" fill="#f5f5f5"/><rect x="16" y="20" width="32" height="24" rx="6" fill="#bbb"/><rect x="20" y="24" width="24" height="16" rx="3" fill="#fff"/></svg> -->
            <div class="wechat-guide-browser-text">{{ isIOS ? $t('message.tip.safari') : $t('message.tip.browser') }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 横屏强制遮罩 -->
    <div v-else-if="!isLandscape" class="landscape-mask">
      <div class="mask-content">
        <div class="rotate-icon">
          <img src="https://img.icons8.com/ios-filled/100/rotate-right.png" alt="rotate" class="rotate-anim"/>
        </div>
        <div class="mask-text">
          <div class="text-cn">请将手机横屏使用</div>
          <div class="text-en">Please rotate your device to landscape mode</div>
        </div>
        <div class="mask-sub-text">
          <div class="text-cn">为了获得最佳体验，请横屏查看</div>
          <div class="text-en">For the best viewing experience, please use landscape orientation</div>
        </div>
        <div class="mask-lock-tip">
          <div class="lock-tip-header">
            <div class="lock-tip-icon">
              <a-icon type="lock" />
            </div>
            <div class="text-cn">请关闭竖屏锁定</div>
          </div>
          <div class="text-en">Please turn off portrait orientation lock</div>
        </div>
      </div>
    </div>
    <div v-else class="mobile-content">
      <!-- 左上角 Logo -->
      <div class="mobile-logo">
        <img src="../assets/17dba2e30afc8590182254fe68bcc7b0.png" alt="logo" />
      </div>
      <!-- 左侧菜单按钮 -->
      <div class="mobile-menu-btn">
        <div class="vertical-btn menu-vertical-btn" @click="showPanel = true" data-btn="switchPattern">
          <a-icon type="menu" class="vertical-btn-icon" />
          <span class="vertical-btn-text">{{ $t('message.button.switchPattern') }}</span>
        </div>
      </div>
      <!-- 右侧悬浮按钮组 -->
      <div class="mobile-float-btns new-vertical-btns">
        <div class="vertical-btn" @click="toggleLanguage">
          <a-icon type="global" class="vertical-btn-icon" />
          <span class="vertical-btn-text">{{ $i18n.locale === 'zh' ? 'English' : '中文' }}</span>
        </div>
        <div class="vertical-btn" @click="toggleMusic">
          <img src="../assets/yinyue.svg" alt="music" class="vertical-btn-icon" />
          <span class="vertical-btn-text">{{ isMusicPlaying ? $t('message.button.pause') : $t('message.button.play') }}</span>
        </div>
        <div class="vertical-btn" @click="handleShare">
          <a-icon type="share-alt" class="vertical-btn-icon" />
          <span class="vertical-btn-text">{{ $t('message.button.share') }}</span>
        </div>
        <div v-if="selectedPattern" class="vertical-btn" :class="{ active: viewMode === 'full' }" @click="viewMode = 'full'">
          <a-icon type="picture" class="vertical-btn-icon" />
          <span class="vertical-btn-text">{{ $t('message.viewMode.full') }}</span>
        </div>
        <div v-if="selectedPattern" class="vertical-btn" :class="{ active: viewMode === 'empty' }" @click="viewMode = 'empty'" data-btn="viewEmpty">
          <img :src="viewMode === 'empty' ? require('../assets/water-off.svg') : require('../assets/water-on.svg')" alt="" class="vertical-btn-icon" />
          <span class="vertical-btn-text">{{ $t('message.viewMode.empty') }}</span>
        </div>
        <div v-if="selectedPattern" class="vertical-btn" :class="{ active: viewMode === 'detail' }" @click="viewMode = 'detail'" data-btn="viewDetail">
          <a-icon type="zoom-in" class="vertical-btn-icon" />
          <span class="vertical-btn-text">{{ $t('message.viewMode.detail') }}</span>
        </div>
      </div>
      <!-- 左侧弹出面板 -->
      <transition name="slide-left">
        <div v-if="showPanel" class="mobile-side-panel">
          <a-button shape="circle" class="panel-close-btn" @click="showPanel = false">
            <a-icon type="left" />
          </a-button>
          <div class="panel-header">
            <!-- <img class="panel-logo" src="../assets/logo.png" alt="logo" /> -->
            <img class="panel-logo" src="../assets/17dba2e30afc8590182254fe68bcc7b0.png" alt="logo" />
          </div>
          <div class="panel-scroll">
            <!-- 类型选择 -->
            <div v-if="panelView === 'category'">
              <div class="mobile-card-list">
                <div
                  v-for="category in categories"
                  :key="category.id"
                  class="mobile-card"
                  :class="{ selected: selectedCategoryId === category.id }"
                  @click="selectCategory(category)"
                >
                  <img v-if="category.image" :src="categoryImageUrl(category)" :alt="categoryName(category)" />
                  <div class="mobile-card-name">{{ categoryName(category) }}</div>
                </div>
              </div>
            </div>
            <!-- 花色选择 -->
            <div v-else>
              <a-button class="panel-back-btn" @click="panelView = 'category'" type="default" block>
                <a-icon type="arrow-left" /> {{ $t('message.backToCategories') }}
              </a-button>
              <div class="mobile-card-list" style="margin-top:18px;">
                <div
                  v-for="item in patterns"
                  :key="item.id"
                  class="mobile-card"
                  :class="{ selected: selectedPattern && selectedPattern.id === item.id }"
                  @click="selectPattern(item)"
                >
                  <img :src="patternImageUrl(item)" :alt="patternName(item)" />
                  <div class="mobile-card-name">{{ patternName(item) }}</div>
                </div>
                <div v-if="!patternsLoading && patterns.length === 0" class="no-patterns-message">
                  {{ $t('message.noPatterns') }}
                </div>
                <div v-if="hasMore" class="load-more-container">
                  <a-button 
                    type="primary" 
                    :loading="isLoadingMore"
                    @click="loadMore"
                    class="load-more-btn"
                  >
                    {{ isLoadingMore ? $t('message.loading') : $t('message.loadMore') }}
                  </a-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!-- 主图区全屏 -->
      <div class="mobile-pool-view">
        <a-spin :spinning="imageLoading" tip="图片加载中...">
          <div class="mobile-image-container" :class="{ 'no-pattern': !currentView }">
            <img
              v-if="currentView"
              :src="currentView"
              :alt="viewMode"
              @load="handleImageLoad"
              @error="handleImageError"
              class="mobile-pool-image"
            />
            <div v-else class="choose-pattern-tip">
              <a-icon type="info-circle" style="font-size: 32px; color: #1890ff;" />
              <div class="tip-text">{{ $t('message.tip.choosePattern') }}</div>
            </div>
          </div>
        </a-spin>
      </div>
      <!-- 背景音乐 -->
      <audio ref="bgMusic" loop :src="musicUrl"></audio>
    </div>
  </div>
</template>

<script>
import request from '@/utils/requestWap.js'

export default {
  name: 'Mobile',
  data() {
    return {
      isLandscape: false,
      isMusicPlaying: true,
      viewMode: 'full',
      loading: false,
      patternsLoading: false,
      imageLoading: false,
      categories: [],
      selectedCategoryId: null,
      patterns: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      selectedPattern: null,
      musicUrl: '',
      showPanel: false,
      panelView: 'category',
      showLoading: true,
      loadingPercent: 0,
      imagesToLoad: [],
      loadedImagesCount: 0,
      isLoadingMore: false,
      hasMore: true,
      isWechat: false,
      showWechatGuide: true,
      isIOS: false,
    }
  },
  computed: {
    currentView() {
      if (!this.selectedPattern) return ''
      let imageUrl = ''
      if (this.viewMode === 'full') {
        imageUrl = this.selectedPattern.have_image
      } else if (this.viewMode === 'empty') {
        imageUrl = this.selectedPattern.not_image
      } else if (this.viewMode === 'detail') {
        imageUrl = this.selectedPattern.detail_image
      }
      if (!imageUrl) return ''
      try {
        imageUrl = decodeURIComponent(imageUrl)
        imageUrl = imageUrl.replace(/\\/g, '')
        if (!imageUrl.startsWith('http')) {
          imageUrl = 'https://poollineradminwap.landy360.com' + imageUrl
        }
        return imageUrl
      } catch (e) {
        return ''
      }
    }
  },
  mounted() {
    this.checkOrientation();
    window.addEventListener('resize', this.checkOrientation);
    window.addEventListener('orientationchange', this.checkOrientation);
    // 添加屏幕方向变化事件监听
    if (window.screen && window.screen.orientation) {
      window.screen.orientation.addEventListener('change', this.checkOrientation);
    }
    this.initWithLoading();
    this.checkWechat();
    this.checkIOS();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkOrientation);
    window.removeEventListener('orientationchange', this.checkOrientation);
    if (window.screen && window.screen.orientation) {
      window.screen.orientation.removeEventListener('change', this.checkOrientation);
    }
  },
  methods: {
    async initWithLoading() {
      this.showLoading = true;
      this.loadingPercent = 0;
      this.imagesToLoad = [];
      this.loadedImagesCount = 0;
      // 解析URL参数
      const searchParams = new URLSearchParams(window.location.search);
      const urlCateId = searchParams.get('cateId');
      const urlPatternId = searchParams.get('patternId');
      try {
        // 1. 获取类型列表
        const cateRes = await request({ url: '/index/cateList', method: 'get' });
        this.loadingPercent = 30;
        if (cateRes && cateRes.data && Array.isArray(cateRes.data)) {
          this.categories = cateRes.data;
          let targetCate = null;
          // 优先用URL参数cateId
          if (urlCateId) {
            targetCate = this.categories.find(c => String(c.id) === String(urlCateId));
          }
          // 没有就用默认
          if (!targetCate) {
            targetCate = this.categories.find(c => c.is_default === 2);
          }
          if (targetCate) {
            this.selectedCategoryId = targetCate.id;
            // 2. 获取该类型下的花色
            const patternRes = await request({
              url: '/index/sceneList',
              method: 'get',
              params: {
                cate_id: targetCate.id,
                page: 1,
                limit: this.pageSize
              }
            });
            this.loadingPercent = 60;
            this.patterns = Array.isArray(patternRes.data && patternRes.data.list) ? patternRes.data.list : [];
            this.total = patternRes.data && patternRes.data.count ? patternRes.data.count : 0;
            let targetPattern = null;
            // 优先用URL参数patternId
            if (urlPatternId) {
              targetPattern = this.patterns.find(p => String(p.id) === String(urlPatternId));
            }
            // 没有就用默认
            if (!targetPattern) {
              targetPattern = this.patterns.find(p => p.is_default === 2);
            }
            if (!targetPattern && this.patterns.length > 0) {
              targetPattern = this.patterns[0];
            }
            this.selectedPattern = targetPattern;
            // 默认显示分类选择页面
            this.panelView = 'category';
            // 3. 预加载所有图片
            await this.preloadImages();
          }
        }
      } catch (e) {
        console.error('初始化加载失败:', e);
      } finally {
        // 访问日志和音乐等其他初始化
        request({ url: '/index/visitLog', method: 'get' });
        this.fetchMusicUrl();
      }
    },
    async preloadImages() {
      const images = []
      
      // 收集所有需要预加载的图片URL
      if (this.selectedPattern) {
        if (this.selectedPattern.have_image) images.push(this.selectedPattern.have_image)
        if (this.selectedPattern.not_image) images.push(this.selectedPattern.not_image)
        if (this.selectedPattern.detail_image) images.push(this.selectedPattern.detail_image)
      }
      
      // 收集分类图片
      this.categories.forEach(category => {
        if (category.image) images.push(category.image)
      })
      
      // 收集花色图片
      this.patterns.forEach(pattern => {
        if (pattern.image) images.push(pattern.image)
      })
      
      this.imagesToLoad = images
      this.loadedImagesCount = 0
      
      // 预加载所有图片
      const loadPromises = images.map(url => {
        return new Promise((resolve, reject) => {
          const img = new Image()
          img.onload = () => {
            this.loadedImagesCount++
            this.loadingPercent = 60 + Math.floor((this.loadedImagesCount / this.imagesToLoad.length) * 40)
            resolve()
          }
          img.onerror = () => {
            this.loadedImagesCount++
            this.loadingPercent = 60 + Math.floor((this.loadedImagesCount / this.imagesToLoad.length) * 40)
            resolve() // 即使加载失败也继续
          }
          img.src = this.processImageUrl(url)
        })
      })
      
      await Promise.all(loadPromises)
      this.loadingPercent = 100
      
      // 延迟关闭加载页面，确保动画流畅
      setTimeout(() => {
        this.showLoading = false
      }, 400)
    },
    processImageUrl(url) {
      if (!url) return ''
      try {
        url = decodeURIComponent(url)
        url = url.replace(/\\/g, '')
        if (!url.startsWith('https')) {
          url = 'https://poollineradminwap.landy360.com' + url
        }
        return url
      } catch (e) {
        console.error('处理图片URL失败:', url, e)
        return url
      }
    },
    checkOrientation() {
      // 使用多种方法检测横屏状态
      const isLandscape = 
        window.innerWidth > window.innerHeight || // 宽高比
        (window.screen && window.screen.orientation && window.screen.orientation.type.includes('landscape')) || // 屏幕方向API
        (window.orientation === 90 || window.orientation === -90); // 旧版方向API
      
      this.isLandscape = isLandscape;
      
      // 如果是竖屏，尝试强制横屏
      if (!isLandscape && window.screen && window.screen.orientation) {
        try {
          window.screen.orientation.lock('landscape').catch(() => {
            console.log('无法强制横屏');
          });
        } catch (e) {
          console.log('不支持强制横屏');
        }
      }
    },
    async fetchMusicUrl() {
      try {
        const res = await request({
          url: '/index/configData',
          method: 'get',
          params: { name: 'music' }
        })
        if (res && res.data && res.data.content) {
          this.musicUrl = res.data.content
          this.$nextTick(() => {
            this.playMusic()
          })
        }
      } catch (error) {}
    },
    async fetchPatterns(categoryId, isLoadMore = false) {
      if (!categoryId) {
        this.patternsLoading = false
        this.patterns = []
        this.total = 0
        return
      }
      
      if (isLoadMore) {
        if (this.isLoadingMore || !this.hasMore) return
        this.isLoadingMore = true
      } else {
        this.patternsLoading = true
        this.currentPage = 1
        this.patterns = []
        this.hasMore = true
      }

      try {
        const res = await request({
          url: '/index/sceneList',
          method: 'get',
          params: {
            cate_id: categoryId,
            page: this.currentPage,
            limit: this.pageSize
          }
        })
        
        const newPatterns = Array.isArray(res.data && res.data.list) ? res.data.list : []
        this.total = res.data && res.data.count ? res.data.count : 0
        
        if (isLoadMore) {
          this.patterns = [...this.patterns, ...newPatterns]
        } else {
          this.patterns = newPatterns
        }
        
        this.hasMore = this.patterns.length < this.total
        
        if (this.patterns.length > 0 && !isLoadMore) {
          if (!this.selectedPattern || !this.patterns.find(p => p.id === this.selectedPattern.id)) {
            this.selectPattern(this.patterns[0])
          }
        }
      } catch (error) {
        console.error('获取花色列表失败：', error)
        this.$message.error(this.$t('message.fetchPatternsError') || '获取花色列表失败')
        if (!isLoadMore) {
          this.patterns = []
          this.total = 0
          this.selectedPattern = null
        }
      } finally {
        this.patternsLoading = false
        this.isLoadingMore = false
      }
    },
    handleScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      // 当滚动到距离底部20px时触发加载
      if (scrollHeight - scrollTop - clientHeight < 20) {
        if (this.hasMore && !this.isLoadingMore) {
          this.currentPage++
          this.fetchPatterns(this.selectedCategoryId, true)
        }
      }
    },
    selectCategory(category) {
      this.selectedCategoryId = category.id
      this.currentPage = 1
      this.patterns = []
      this.total = 0
      this.selectedPattern = null
      this.fetchPatterns(category.id).then(() => {
        this.panelView = 'pattern'
      }).catch(() => {
        this.panelView = 'pattern'
      })
    },
    toggleLanguage() {
      const newLocale = this.$i18n.locale === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = newLocale
    },
    toggleMusic() {
      if (!this.musicUrl) {
        this.$message.warning(this.$t('message.musicLoading'))
        return
      }
      if (this.isMusicPlaying) {
        this.$refs.bgMusic.pause()
      } else {
        const playPromise = this.$refs.bgMusic.play()
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log('播放失败，需要用户交互:', error)
          })
        }
      }
      this.isMusicPlaying = !this.isMusicPlaying
    },
    playMusic() {
      if (!this.musicUrl) return
      this.isMusicPlaying = false
    },
    handleShare() {
      let url = window.location.origin + window.location.pathname
      if (this.selectedCategoryId && this.selectedPattern && this.selectedPattern.id) {
        url += `?cateId=${this.selectedCategoryId}&patternId=${this.selectedPattern.id}`
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          this.$message.success(this.$t('message.copySuccess'))
          if (this.$info) {
            this.$info({
              title: this.$t('message.button.share'),
              content: url,
              okText: this.$t('message.button.back')
            })
          }
        }).catch(() => {
          this.fallbackCopyTextToClipboard(url)
        })
      } else {
        this.fallbackCopyTextToClipboard(url)
      }
    },
    fallbackCopyTextToClipboard(text) {
      // 创建临时 input 元素
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$message.success(this.$t('message.copySuccess'))
        if (this.$info) {
          this.$info({
            title: this.$t('message.button.share'),
            content: text,
            okText: this.$t('message.button.back')
          })
        }
      } catch (err) {
        this.$message.error(this.$t('message.copyFailed') || '复制失败，请手动复制链接')
      }
      document.body.removeChild(input)
    },
    selectPattern(pattern) {
      this.imageLoading = true
      this.selectedPattern = pattern
      this.viewMode = 'full'
    },
    patternName(item) {
      return this.$i18n.locale === 'zh' ? (item.china_name || '') : (item.english_name || '')
    },
    patternImageUrl(item) {
      if (!item) return ''
      let url = item.have_image || item.not_image || item.detail_image || ''
      if (url.startsWith('/')) {
        return 'https://poollineradminwap.landy360.com' + url
      }
      return url
    },
    categoryName(categoryItem) {
      if (!categoryItem) return ''
      return this.$i18n.locale === 'zh' ? categoryItem.name : categoryItem.english
    },
    categoryImageUrl(category) {
      if (!category || !category.image) return ''
      let imageUrl = category.image
      if (imageUrl.startsWith('/')) {
        if (!imageUrl.startsWith('http://') && !imageUrl.startsWith('https://')) {
          return 'https://poollineradminwap.landy360.com' + imageUrl
        }
      }
      return imageUrl
    },
    handleImageLoad() {
      this.imageLoading = false
    },
    handleImageError() {
      this.imageLoading = false
    },
    checkWechat() {
      const ua = navigator.userAgent.toLowerCase();
      this.isWechat = ua.indexOf('micromessenger') !== -1;
    },
    checkIOS() {
      const ua = navigator.userAgent;
      this.isIOS = /iPhone|iPad|iPod/i.test(ua);
    },
    openInBrowser() {
      // 获取当前URL
      const currentUrl = window.location.href;
      // 尝试使用系统浏览器打开
      if (window.navigator && window.navigator.share) {
        window.navigator.share({
          title: '泳池换装',
          text: '泳池换装',
          url: currentUrl
        }).catch(() => {
          // 如果分享失败，复制链接
          this.copyToClipboard(currentUrl);
        });
      } else {
        // 如果不支持分享，复制链接
        this.copyToClipboard(currentUrl);
      }
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success(this.$t('message.copySuccess'))
      }).catch(() => {
        this.$message.error(this.$t('message.copyFailed'))
      })
    },
    loadMore() {
      this.fetchPatterns(this.selectedCategoryId, true)
    },
  },
  watch: {
    viewMode: {
      handler(newMode) {
        this.imageLoading = true
        // 预加载新场景的图片
        const img = new Image()
        img.src = this.currentView
        img.onload = () => {
          this.handleImageLoad()
        }
        img.onerror = () => {
          this.handleImageError()
        }
      }
    }
  }
}
</script>

<style scoped>
.mobile-home {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
}

.mobile-home.landscape {
  width: 100vw;
  height: 100vh;
}

.landscape-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.mask-content {
  text-align: center;
  color: #fff;
  padding: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 90%;
  width: 400px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.rotate-icon {
  width: 100px;
  height: 100px;
  margin: 0 auto 30px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.rotate-anim {
  width: 100%;
  height: 100%;
  animation: rotate 2s linear infinite;
}

.mask-text {
  margin-bottom: 20px;
}

.mask-text .text-cn {
  font-size: 24px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 12px;
  line-height: 1.4;
}

.mask-text .text-en {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.4;
}

.mask-sub-text {
  color: rgba(255, 255, 255, 0.7);
}

.mask-sub-text .text-cn {
  font-size: 16px;
  margin-bottom: 8px;
  line-height: 1.4;
}

.mask-sub-text .text-en {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.4;
}

.mask-lock-tip {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.lock-tip-header {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.lock-tip-icon {
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  top: -1px;
}

.lock-tip-icon .anticon {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
}

.mask-lock-tip .text-cn {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.4;
}

.mask-lock-tip .text-en {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.4;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.mobile-float-btns {
  position: fixed;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
}

.function-btns {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.viewmode-btns {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
}

.viewmode-btn {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
  transition: all 0.3s;
  background: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
}

.viewmode-btn:hover {
  background: rgba(255, 255, 255, 0.75);
  transform: translateX(-2px);
}

.viewmode-btn.active {
  background: rgba(24, 144, 255, 0.3);
  border-color: rgba(24, 144, 255, 0.5);
}

.viewmode-btn .anticon {
  font-size: 24px;
  color: #333;
}

.viewmode-btn img {
  width: 24px;
  height: 24px;
}

.float-btn {
  width: 50px !important;
  height: 50px !important;
  background: rgba(255, 255, 255, 0.65) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: #333 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.float-btn:hover {
  background: rgba(255, 255, 255, 0.75) !important;
  transform: translateX(-2px);
}

.float-btn.ant-btn-primary {
  background: rgba(24, 144, 255, 0.3) !important;
  border-color: rgba(24, 144, 255, 0.5) !important;
}

.mobile-side-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 80%;
  max-width: 300px;
  height: 100vh;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 1001;
  padding: 10px 10px;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.panel-close-btn {
  position: absolute;
  right: -40px;
  top: 20px;
  width: 40px !important;
  height: 40px !important;
  background: rgba(24, 144, 255, 0.8) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 0 20px 20px 0 !important;
}

.panel-header {
  text-align: center;
  margin-bottom: 15px;
  padding: 8px 0;
}

.panel-logo {
  width: 120px;
  max-width: 60%;
  height: auto;
}

.panel-scroll {
  height: calc(100% - 80px);
  overflow-y: auto;
  padding-right: 10px;
}

.panel-back-btn {
  margin-bottom: 15px;
  background: rgba(255, 255, 255, 0.65) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: #333 !important;
}

.mobile-card-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.mobile-card {
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.mobile-card:hover {
  border-color: rgba(24, 144, 255, 0.5);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}

.mobile-card.selected {
  border-color: rgba(24, 144, 255, 0.5);
  background: rgba(24, 144, 255, 0.2);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}

.mobile-card img {
  width: 100%;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 8px;
}

.mobile-card-name {
  font-size: 12px;
  color: #333;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-pool-view {
  width: 100vw;
  height: 100vh;
  position: relative;
}

.mobile-image-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-pool-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.choose-pattern-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #333;
}

.tip-text {
  margin-top: 16px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

.no-patterns-message {
  grid-column: span 2;
  text-align: center;
  padding: 20px;
  color: #333;
}

.mobile-pagination {
  margin-top: 20px;
  text-align: center;
}

.mobile-pagination .ant-pagination-item {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.mobile-pagination .ant-pagination-item a {
  color: #333 !important;
}

.mobile-pagination .ant-pagination-item-active {
  background: rgba(24, 144, 255, 0.3) !important;
  border-color: rgba(24, 144, 255, 0.5) !important;
}

@keyframes music-wave {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.music-anim {
  animation: music-wave 1.2s ease-in-out infinite;
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.3s ease;
}

.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(-100%);
}

.loading-page {
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-logo {
  width: 340px;
  max-width: 80vw;
  margin-bottom: 60px;
}

.loading-progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-progress-text {
  margin-bottom: 10px;
  font-size: 16px;
  color: #222;
  font-weight: 500;
  text-align: center;
}

.loading-progress-bar {
  width: 120px;
  height: 28px;
  border: 3px solid #23234a;
  border-radius: 18px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.loading-progress-inner {
  height: 100%;
  background: #23234a;
  border-radius: 18px;
  transition: width 0.3s;
}

.loading-more {
  grid-column: span 2;
  padding: 10px 0;
  text-align: center;
  width: 100%;
}

.wechat-guide-mask {
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  width: 100vw;
  height: 100vh;
  background: #f7f7fa;
  z-index: 99999;
  display: flex;
  flex-direction: column;
}

.wechat-guide-content.no-header {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 0;
}

.wechat-guide-arrow {
  position: absolute;
  top: 0;
  right: 0;
  /* 让箭头更贴近右上角 */
  /* width: 160px; */
  height: 120px;
  pointer-events: none;
}

.wechat-guide-tip {
  margin-top: 60px;
  font-size: 16px;
  color: #333;
  text-align: center;
  font-weight: 500;
}

.wechat-guide-icon-area {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wechat-guide-browser {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wechat-guide-browser-text {
  margin-top: 12px;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.mobile-menu-btn {
  position: fixed;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  z-index: 1000;
}

.menu-vertical-btn {
  width: 70px;
  height: 48px;
  background: rgba(255, 255, 255, 0.65);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid transparent;
  padding: 0;
}

.menu-vertical-btn:hover {
  background: rgba(255,255,255,0.85);
  box-shadow: 0 4px 16px rgba(24,144,255,0.08);
}

.menu-vertical-btn .vertical-btn-icon {
  width: 24px;
  height: 24px;
  font-size: 24px;
  color: #23234a;
  margin-bottom: 0;
  display: block;
}

.new-vertical-btns {
  position: fixed;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
}

.vertical-btn {
  width: 70px;
  height: 48px;
  background: rgba(255, 255, 255, 0.65);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid transparent;
  padding: 0;
}

.vertical-btn:hover {
  background: rgba(255,255,255,0.85);
  box-shadow: 0 4px 16px rgba(24,144,255,0.08);
}

.vertical-btn.active {
  border: 2px solid #1890ff;
  background: #e6f7ff;
}

.vertical-btn-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
  color: #23234a;
  margin-bottom: 2px;
  display: block;
}

.vertical-btn-text {
  font-size: 12px;
  color: #23234a;
  font-weight: 500;
  text-align: center;
  line-height: 1.1;
  white-space: nowrap;
  margin-top: 2px;
  padding: 0 4px;
}

/* 针对英文特别处理 */
[lang="en"] .vertical-btn-text {
  font-size: 11px;
  letter-spacing: -0.2px;
}

/* 针对特定按钮的文案处理 */
[lang="en"] .vertical-btn[data-btn="switchPattern"] .vertical-btn-text {
  font-size: 9px;
}

[lang="en"] .vertical-btn[data-btn="viewDetail"] .vertical-btn-text {
  font-size: 9px;
}

[lang="en"] .vertical-btn[data-btn="viewEmpty"] .vertical-btn-text {
  font-size: 9px;
}

/* Logo 样式 */
.mobile-logo {
  position: fixed;
  top: 30px;
  left: 20px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.65);
  /* backdrop-filter: blur(10px); */
  /* -webkit-backdrop-filter: blur(10px); */
  border-radius: 8px;
  padding: 6px;
  /* box-shadow: 0 2px 8px rgba(0,0,0,0.04); */
  /* border: 1px solid rgba(255, 255, 255, 0.2); */
}

.mobile-logo img {
  width: 130px;
  height: auto;
  display: block;
}

.load-more-container {
  grid-column: span 2;
  padding: 15px 0;
  text-align: center;
  width: 100%;
}

.load-more-btn {
  min-width: 100px;
  height: 32px;
  border-radius: 16px;
  font-size: 13px;
  background: rgba(24, 144, 255, 0.8);
  border: none;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.load-more-btn:hover {
  background: rgba(24, 144, 255, 1);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
}

.load-more-btn.ant-btn-loading {
  background: rgba(24, 144, 255, 0.6);
}

.load-more-btn .anticon {
  margin-right: 4px;
}
</style> 